module.exports = __webpack_public_path__ + "static/icon-256x256-df579761e5e237826f93c40ae40dc693.png";